import { PortTypeValues } from "../../config";
import { Catalog, CatalogItem } from "./common";

export type LightTechnologyTypes = "incandescent" | "led";
export type LightColorRGB = `${number}|${number}|${number}`;

export type LightCatalog = Catalog & {
    brands:LightFamily[];
    backwardsCompatibilityMap:{
        [key:string]:LightBackwardsCompatibilityMapItem
    }
}

export type LightFamily = {
    id:string;
    name:string;
    colorAndShowLibraries:LightColorAndShowLibrary[];
}

/**
 * @deprecated
 */
export enum LightColorAndShowLibraryPortTypes {
    Relay = "Relay",
    Serial = "Serial"
}

export type LightColorAndShowLibrary = {
    id:string;
    name:string;
    isDefault:boolean;
    /**
     * @deprecated Removed in Catalog v32.
     */
    portType: LightColorAndShowLibraryPortTypes;
    /**
     * Added in Catalog v32.
     */
    portTypesAvailable: PortTypeValues[];
    supportsSyncing:boolean;
    supportsBrightness:boolean;
    supportsSyncingToMusic:boolean;
    supportsCustomColorsAndShows:boolean;
    supportsInstantChanges:boolean;
    supportsBrightnessConfiguration:boolean;
    supportsTwinkleSpeedAndDirection:boolean;
    supportsSpeed:boolean;
    colorsAndShows:LightColorsAndShow[];
    selectionMethods:LightSelectionMethod[];
    kbUrl?:string;
}

/** Type for holding list of light colors merged with custom colors defined by a user Palette */
export type LightColors = LightColorsAndShow & {
    uuid: string
}

/**
 * @see LightInfoFlat for a more general light catalog entry similar to other devices
 */
export type LightInfo = {
    id: string,
    name: string,
    colorAndShowLibrary: LightInfoColorAndShowLibrary,
}

/**
 * Compared to LightInfo, LightInfoFlat based on the CatlogItem similar to other devices.
 * @see LightInfo as alternative type
 */
export type LightInfoFlat = CatalogItem & LightColorAndShowLibrary & {
    selectionMethod: LightSelectionMethod
}

export type LightInfoColorAndShowLibrary = LightColorAndShowLibrary & {
    selectionMethod: LightSelectionMethod
}

export type LightColorsAndShow = {
    order:number;
    name:string;
    description:string;
    isShow:boolean;
    RGB:string;
}

export type LightSelectionMethod = {
    id:string;
    name:string;
    isDefault:boolean;
}

export type LightBackwardsCompatibilityMapItem = {
    CompatibleBrandId:string,
    ColorAndShowLibraryId:string,
    ColorAndShowSelectionMethodId:string
}
